module.exports = __webpack_public_path__ + "static/media/Huis-3-1.e6d32457.jpg";